'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'glass border-b border-white/5 py-3' : 'py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        {/* Logo */}
        <Link href="/home-page" className="flex items-center gap-2 group">
          <div className="relative">
            <Image
              src="/assets/images/LOGO_AQUI_APP_BLANCO_PARA_FONDO_AZUL_VERSION_2-1774626042428.png"
              alt="AQUÍ APP logo"
              width={120}
              height={40}
              className="flex-shrink-0 object-contain"
              priority
            />
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1 px-5 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm">
          {[
            { label: 'Inicio', href: '#hero' },
            { label: 'Cómo Funciona', href: '#como-funciona' },
            { label: 'Categorías', href: '#categorias' },
            { label: 'Partners', href: '#aliados' },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              className="px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-white/60 hover:text-white transition-colors rounded-full hover:bg-white/5"
            >
              {item?.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-3">
          <a
            href="#registro"
            className="hidden sm:flex px-6 py-2.5 bg-primary text-white text-xs font-black uppercase tracking-widest rounded-full hover:scale-105 transition-transform shadow-lg shadow-primary/30"
          >
            ¡Regístrate!
          </a>
          {/* Mobile menu toggle */}
          <button
            className="lg:hidden p-2 text-white/70 hover:text-white"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menú"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {menuOpen ? (
                <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" strokeLinecap="round" />
                  <line x1="3" y1="12" x2="21" y2="12" strokeLinecap="round" />
                  <line x1="3" y1="18" x2="21" y2="18" strokeLinecap="round" />
                </>
              )}
            </svg>
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden glass border-t border-white/5 mt-2 px-6 py-4 space-y-2">
          {[
            { label: 'Inicio', href: '#hero' },
            { label: 'Cómo Funciona', href: '#como-funciona' },
            { label: 'Categorías', href: '#categorias' },
            { label: 'Partners', href: '#aliados' },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              onClick={() => setMenuOpen(false)}
              className="block px-4 py-3 text-sm font-bold uppercase tracking-widest text-white/70 hover:text-white transition-colors"
            >
              {item?.label}
            </a>
          ))}
          <a
            href="#registro"
            onClick={() => setMenuOpen(false)}
            className="block mt-2 px-6 py-3 bg-primary text-white text-xs font-black uppercase tracking-widest rounded-full text-center"
          >
            ¡Regístrate!
          </a>
        </div>
      )}
    </header>
  );
}